import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import { DigiKeyV4CredentialsDTORuntype, DigiKeyV4ResponseBodyDTORuntype } from './digikeyV4BackendTypes';

export const digikeyV4Endpoints = {
    'GET /3rdparty/digikeyv4/credentials': endpoint({
        description: 'Returns credentials for digikeyv4 integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: DigiKeyV4ResponseBodyDTORuntype,
    }),
    'POST /3rdparty/digikeyv4/credentials': endpoint({
        description: 'Uploads credentials for digikeyv4 integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: DigiKeyV4CredentialsDTORuntype,
        responseBody: DigiKeyV4ResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/digikeyv4/credentials'],
    }),
    'PATCH /3rdparty/digikeyv4/credentials': endpoint({
        description: 'Updates credentials for digikeyv4 integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: DigiKeyV4CredentialsDTORuntype,
        responseBody: DigiKeyV4ResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/digikeyv4/credentials'],
    }),
    'DELETE /3rdparty/digikeyv4/credentials': endpoint({
        description: 'Deletes existing credentials for digikeyv4 integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({ deleted: z.number() }),
        invalidates: ['GET /3rdparty/digikeyv4/credentials'],
    }),
};
